export default __webpack_public_path__ + "static/media/asterisk.9df6a1fd.svg";